<template>
  <v-dialog v-model="dialog" persistent width="980px">
    <v-card>
      <v-card-title class="headline mb-0">
        <v-icon>remove_red_eye</v-icon> Ver permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-3 py-0">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="texto">
                <strong>Número:</strong> {{ permiso.numero }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <h3 class="texto">
                <strong>Funcionario:</strong> {{ permiso.nombres }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <h3 class="texto">
                <strong>Tipo de papeleta:</strong> {{ permiso.tipo_permiso }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <h3 class="texto">
                <b>
                  {{ permiso.id_parametro_permiso ? tipo_capacitacion : "" }}
                </b>
              </h3>
            </v-flex>
            <!--<v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == 8">
							<h3><strong>Lugar de atencion:</strong>   {{ permiso.lugar_atencion }}</h3>
						</v-flex > -->
            <v-flex
              xs12
              v-if="
                permiso.permiso.id_tipo_permiso == '87' ||
                  permiso.permiso.id_tipo_permiso == '103'
              "
            >
              <h3 class="texto">
                <strong>Lugar de comisión :</strong> {{ permiso.permiso.lugar }}
              </h3>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.permiso.id_tipo_permiso == '87' ||
                permiso.permiso.id_tipo_permiso == '104' ||
                  permiso.permiso.id_tipo_permiso == '96' ||
                  permiso.permiso.id_tipo_permiso == '101' ||
                  permiso.permiso.id_tipo_permiso == '103'
              "
            >
              <h3 class="texto">
                <strong>Motivo:</strong> {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '90'">
              <h3 class="texto">
                <strong>Tipo de baja:</strong>
                {{
                  permiso.id_tipo_permiso == 90 &&
                  permiso.motivo !=
                    "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
                    ? permiso.motivo
                    : permiso.motivo ==
                        "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)" &&
                      permiso.id_tipo_permiso == 90
                    ? "OTROS"
                    : "OTROS"
                }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '61'">
              <h3 class="texto">
                <strong>Fecha de nacimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '61'">
              <h3 class="texto">
                <strong>Hora de nacimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '6'">
              <h3 class="texto">
                <strong>Fecha de fallecimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '6'">
              <h3 class="texto">
                <strong>Hora de fallecimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '12'">
              <h3 class="texto">
                <strong>Fecha de matrimonio:</strong>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '44'">
              <h3 class="texto">
                <strong>Condición o estado crítico de salud:</strong>
                {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_estado == 9">
              <h3 class="texto">
                <strong>Motivo de la anulación:</strong>
                {{ permiso.justificacion }}
              </h3>
            </v-flex>
          </v-layout>
          <span class="titulo">Detalles de papeleta</span>
          <v-layout>
            <v-flex
              xs12
              v-if="
                permiso.permiso.id_tipo_permiso == 87 ||
                permiso.permiso.id_tipo_permiso == 104 ||
                  permiso.permiso.id_tipo_permiso == 96 ||
                  permiso.permiso.id_tipo_permiso == 88 ||
                  permiso.permiso.id_tipo_permiso == 102 ||
                  (permiso.permiso.id_tipo_permiso >= 37 &&
                    permiso.permiso.id_tipo_permiso <= 43)
              "
            >
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1 tabla-comprimida-light"
                hide-actions
                :headers="headers_horas"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                    <!-- {{
                      ($moment(props.item.hora_hasta,'HH:mm')).diff($moment(props.item.hora_desde,'HH:mm'),"hours")
                    }} -->
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos justificativo caja nro 8 -->
          <v-layout v-if="permiso.permiso.id_tipo_permiso == 8">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1 tabla-comprimida-light"
                hide-actions
                :headers="headers_caja"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_desde, "HH:mm")
                        .subtract("00:25")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>

                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_hasta, "HH:mm")
                        .add("00:25")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                  <td
                    v-if="permiso.id_tipo_permiso == 24"
                    class="text-xs-center"
                  >
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1 tabla-comprimida-light"
                hide-actions
                :headers="headers_dias_decimales"
                v-if="
                  permiso.permiso.id_tipo_permiso == 14 ||
                  permiso.permiso.id_tipo_permiso == 105 ||
                    (permiso.permiso.id_tipo_permiso >= 98 &&
                      permiso.permiso.id_tipo_permiso <= 101) ||
                    permiso.permiso.id_tipo_permiso == 89 ||
                    permiso.permiso.id_tipo_permiso == 18
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_dias"
                v-if="
                  [6, 44, 95, 61, 12, 90, 5].includes(
                    parseInt(permiso.permiso.id_tipo_permiso)
                  )
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1 tabla-comprimida-light"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permiso nro 24 y 103 -->
          <v-layout v-if="permiso.permiso.id_tipo_permiso == 24">
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="permiso_detalles"
                hide-actions
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <!--  total horas-->
                  <!-- <td v-if="(props.item.hora_desde=='08:30' || props.item.hora_desde=='08:00')&& (props.item.hora_hasta=='12:00' || props.item.hora_hasta=='12:30')" class="text-xs-center">Solo mañana</td>
										<td v-if="(props.item.hora_desde=='12:30' || props.item.hora_desde=='12:00')&& (props.item.hora_hasta=='16:30' || props.item.hora_hasta=='16:00')" class="text-xs-center"> Solo tarde</td>
										<td v-if="(props.item.hora_desde=='08:30' || props.item.hora_desde=='08:00')&& (props.item.hora_hasta=='16:00' || props.item.hora_hasta=='16:30' )" class="text-xs-center">Todo el dìa</td> -->
                  <!-- <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td> -->
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  <td class="text-xs-center">
                    {{ props.item.estado_detalle }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permiso nro 103 -->
          <v-layout v-if="permiso.permiso.id_tipo_permiso == 103">
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <!--  total horas-->
                  <!-- <td v-if="(props.item.hora_desde=='08:30' || props.item.hora_desde=='08:00')&& (props.item.hora_hasta=='12:00' || props.item.hora_hasta=='12:30')" class="text-xs-center">Solo mañana</td>
										<td v-if="(props.item.hora_desde=='12:30' || props.item.hora_desde=='12:00')&& (props.item.hora_hasta=='16:30' || props.item.hora_hasta=='16:00')" class="text-xs-center"> Solo tarde</td>
										<td v-if="(props.item.hora_desde=='08:30' || props.item.hora_desde=='08:00')&& (props.item.hora_hasta=='16:00' || props.item.hora_hasta=='16:30' )" class="text-xs-center">Todo el dìa</td> -->
                  <!-- <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td> -->
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  <td class="text-xs-center">
                    {{ props.item.estado_detalle }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              v-if="permiso.tipo_permiso == 'PERMISO A CUENTA DE VACACIÓN'"
            >
              <h4>
                <strong>Total horas: {{ horas_solicitadas.toFixed(2) }}</strong>
              </h4>
            </v-flex>
          </v-layout>

          <h3
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <strong>Detalles compensacion</strong>
          </h3>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_desde, "HH:mm:ss").format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_hasta, "HH:mm:ss").format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.diferencia_horas, "HH:mm:ss").format(
                        "HH:mm"
                      )
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <h4
                v-if="
                  permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso == 96 &&
                      permiso.compensa_tolerancia == 1)
                "
              >
                <strong>Total horas: {{ total_horas_acomuladas }}</strong>
              </h4>
            </v-flex>
          </v-layout>
          <span class="titulo">Seguimiento de papeleta</span>
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :items="detalle_seguimiento"
                class="elevation-1 tabla-comprimida-light"
                hide-actions
                :headers="headers_detalle"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.estado }}</td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                  <td class="text-xs-center">
                    {{
                      props.item.jefe &&
                      (props.item.id_estado == 6 ||
                        props.item.id_estado == 21) &&
                      (permiso.id_tipo_permiso == 24 ||
                        permiso.id_tipo_permiso == 14 ||
                        permiso.id_tipo_permiso == 105 ||
                        permiso.id_tipo_permiso == 94 ||
                        permiso.id_tipo_permiso == 88 ||
                        permiso.id_tipo_permiso == 87 ||
                        permiso.id_tipo_permiso == 104 ||
                        permiso.id_tipo_permiso == 61 ||
                        permiso.id_tipo_permiso == 12 ||
                        permiso.id_tipo_permiso == 89 ||
                        permiso.id_tipo_permiso == 6 ||
                        (permiso.id_tipo_permiso >= 37 &&
                          permiso.id_tipo_permiso <= 43))
                        ? props.item.jefe
                        : (permiso.id_tipo_permiso == 90 ||
                            permiso.id_tipo_permiso == 18 ||
                            permiso.id_tipo_permiso == 95 ||
                            permiso.id_tipo_permiso == 8 ||
                            permiso.id_tipo_permiso == 96 ||
                            //permiso.id_tipo_permiso == 89 ||
                            permiso.id_tipo_permiso == 100 ||
                            permiso.id_tipo_permiso == 98 ||
                            permiso.id_tipo_permiso == 101 ||
                            permiso.id_tipo_permiso == 99) &&
                          props.item.id_estado == 6
                        ? "RECURSOS HUMANOS"
                        : ""
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.motivo }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-3">
        <v-spacer></v-spacer>
        <v-btn color="error" type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogVerPermiso", async item => {
      this.permiso = item;

      (this.permiso_detalles2 = [
        {
          fecha_salida: this.permiso.fecha_desde,
          fecha_hasta: this.permiso.fecha_retorno,
          hora_desde: this.permiso.hora_desde,
          hora_hasta: this.permiso.hora_hasta,
          total_horas: this.permiso.horas_permiso,
          total_dias: this.permiso.nro_dias
        }
      ]),
        this.total_horas();
      await this.getDetallePermiso(item.id_permiso);
      this.verPermisosCompensacion(item.id_permiso);
      this.getDetalleSeguimiemto(this.permiso.id_permiso);
      if (this.permiso.id_tipo_permiso == 5) {
        this.tipo_capacitacion = await this.obtenerAgenteCapacitacion(
          this.permiso.id_parametro_permiso
        );
      }

      //this.verSeguimientoDetalle(item.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,
      total_horas_acomuladas: 0,
      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalles2: [],
      vDetallePermisos: {},
      tipo_capacitacion: [],
      loading: false,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        // {
        //   text: "Rango Horas",
        //   sortable: false,
        //   align: "center"
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_caja: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "tolerancia",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },

        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Tolerancia hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario destinatario",
          sortable: false,
          align: "center"
        },
        {
          text: "Motivo de rechazo",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  methods: {
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
    },
    // Metodo para obtener tipos de capacitacion censo
    async obtenerAgenteCapacitacion(id_parametro) {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              param(id:${id_parametro}){
                valor
              }
            }
          `
        });
        return res.param.valor;
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        //obtener el antiguo seguimiento
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;

        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
			      query{
              vDetallePermisos(lista_estados:"22,9,6,7,16,21",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
                  total_dias
                  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;
        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },

    aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`
        })
        .then(response => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },
    sumar_horas(permiso_detalles) {
      if (this.permiso.id_tipo_permiso != 90) {
        let total = 0;
        permiso_detalles.forEach(item => {
          total +=
            this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
              item.fecha_desde + " " + item.hora_desde,
              "minutes"
            ) / 60;
        });
        this.horas_solicitadas = total;
      }
    },
    sumar_horas_compensa(permiso_detalles) {
      if (this.permiso.id_tipo_permiso != 90) {
        let total_comp = 0;
        permiso_detalles.forEach(item => {
          total_comp +=
            this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
              item.fecha_desde + " " + item.hora_desde,
              "minutes"
            ) / 60;
        });
        this.horas_solicitadas_comp = total_comp;
      }
    },

    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>
<style lang="scss" scoped>
.titulo {
  font-size: 1.5rem !important;
  color: rgb(24, 77, 121);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
  margin: 0 !important;
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(14, 187, 178, 0.35);
  font-size: 1.5em;
  color: rgba(24, 106, 121, 1);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/VerPermiso.vue